/* CAUTION, THIS FILE IS AUTO-GENERATED */
/* eslint-disable */
import React from 'react';
import PropTypes from 'prop-types';
import { withIconFlavour } from '../withIconFlavour';

const IconCorePhone = ({ size = 16, className = '', ...props }) => (
  <svg
    {...props}
    className={className}
    width={size}
    height={size}
    viewBox="0 0 16 16"
  >
    <path
      fill="currentColor"
      d="M15.511 3.111c0-.004-.004-.006-.004-.01a.484.484 0 0 0-.127-.305c-.009-.011-.005-.028-.016-.039L13.243.636a.5.5 0 0 0-.707 0l-2.121 2.121a.5.5 0 0 0-.094.578l1.253 2.506-5.733 5.733-2.506-1.253a.499.499 0 0 0-.577.094L.636 12.536a.503.503 0 0 0 0 .707l2.122 2.121c.01.01.026.006.037.015a.481.481 0 0 0 .316.131H5.99c.133 0 .26-.052.353-.146l9-9a.501.501 0 0 0 .147-.35l.021-2.899-.001-.002.001-.002z"
    />
  </svg>
);

IconCorePhone.displayName = 'IconCorePhone';

IconCorePhone.propTypes = {
  size: PropTypes.number,
  className: PropTypes.string,
};

export default withIconFlavour(IconCorePhone);
IconCorePhone.displayName = 'IconCorePhone';
